import { Component, inject } from '@angular/core';
import { SnackbarService, SnackbarItem } from '../../../../core/services/snackbar.service';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  styles: [`
    .snack-list {
      position: fixed;
      bottom: 1.5rem;
      right: 1.5rem;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      max-width: 22rem;
      width: calc(100vw - 2rem);
      pointer-events: none;
    }
    .snack {
      pointer-events: all;
      display: flex;
      align-items: flex-start;
      gap: 0.625rem;
      padding: 0.75rem 1rem;
      border-radius: 0.75rem;
      font-size: 0.8125rem;
      line-height: 1.4;
      box-shadow: 0 4px 24px -4px rgba(0,0,0,0.45);
      border: 1px solid transparent;
      animation: snack-in 0.2s cubic-bezier(0.34,1.56,0.64,1) both;
    }
    @keyframes snack-in {
      from { opacity: 0; transform: translateY(12px) scale(0.95); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    .snack-success {
      background: rgba(16,185,129,0.12);
      border-color: rgba(16,185,129,0.3);
      color: #6ee7b7;
    }
    .snack-error {
      background: rgba(239,68,68,0.12);
      border-color: rgba(239,68,68,0.3);
      color: #fca5a5;
    }
    .snack-warning {
      background: rgba(245,158,11,0.12);
      border-color: rgba(245,158,11,0.3);
      color: #fcd34d;
    }
    .snack-info {
      background: rgba(6,182,212,0.12);
      border-color: rgba(6,182,212,0.3);
      color: #67e8f9;
    }
    .snack-icon { flex-shrink: 0; margin-top: 1px; font-size: 0.75rem; }
    .snack-msg { flex: 1; word-break: break-word; }
    .snack-close {
      flex-shrink: 0;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0 0 0 0.25rem;
      opacity: 0.5;
      font-size: 0.6875rem;
      line-height: 1;
      color: inherit;
      transition: opacity 0.15s;
    }
    .snack-close:hover { opacity: 1; }
  `],
  template: `
    <div class="snack-list" aria-live="polite">
      @for (item of snackbar.items(); track item.id) {
        <div class="snack snack-{{ item.type }}" role="alert">
          <i class="snack-icon fa-solid {{ iconFor(item) }}"></i>
          <span class="snack-msg">{{ item.message }}</span>
          <button class="snack-close" (click)="snackbar.dismiss(item.id)" aria-label="Tutup">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      }
    </div>
  `,
})
export class SnackbarComponent {
  readonly snackbar = inject(SnackbarService);

  iconFor(item: SnackbarItem): string {
    const map: Record<string, string> = {
      success: 'fa-circle-check',
      error:   'fa-circle-exclamation',
      warning: 'fa-triangle-exclamation',
      info:    'fa-circle-info',
    };
    return map[item.type] ?? 'fa-circle-info';
  }
}
